import { useSelector } from 'react-redux';

import { selectAssessmentTypeOptions } from '../services/selectors';

export const useAssessmentTypeOptions = () => useSelector(selectAssessmentTypeOptions);
